// Pure helper for the accountant dashboard's "Sales per month" panel.
// A sale counts in a month when it CLOSED that month: dealStage "Closed",
// status "Approved", closingdate (YYYY-MM-DD) in the requested year.
// Amounts are stored as .toFixed(2) strings — Number() everything.

export function monthlySales(deals, year) {
  const rows = Array.from({ length: 12 }, () => ({ count: 0, total: 0 }));
  (deals || []).forEach((d) => {
    if (!d) return;
    if (d.dealStage !== "Closed") return;
    if (d.status !== "Approved") return;
    const closing = String(d.closingdate || "");
    if (!closing.startsWith(`${year}-`)) return;
    const month = Number(closing.slice(5, 7));
    if (!month || month < 1 || month > 12) return;
    rows[month - 1].count += 1;
    rows[month - 1].total += Number(d.totalCommissionamount) || 0;
  });
  return rows;
}
